var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"loading"},[_c('img',{staticClass:"loading-gif",attrs:{"src":require("../../images/pages/activities/loading.gif"),"alt":""}}),_vm._v(" 加载中 ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }